import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { LogIn, LogOut, UserPlus } from 'lucide-react';
import { useHeaderAuth } from '@/hooks/useHeaderAuth';

interface AuthButtonsProps {
  isLoggedIn: boolean;
}

export const AuthButtons: React.FC<AuthButtonsProps> = ({ isLoggedIn }) => {
  const { isLoading, handleLogout } = useHeaderAuth();

  if (isLoggedIn) {
    return (
      <Button
        variant="secondary"
        className="bg-white text-primary-blue hover:bg-gray-100 font-semibold shadow-sm"
        onClick={handleLogout}
        disabled={isLoading}
      >
        {isLoading ? (
          <div className="flex items-center">
            <div className="h-4 w-4 animate-spin rounded-full border-2 border-b-transparent mr-2" />
            Logging out...
          </div>
        ) : (
          <>
            <LogOut className="mr-2 h-4 w-4" />
            Logout
          </>
        )}
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Link to="/login" onClick={() => window.scrollTo(0, 0)}>
        <Button
          variant="outline"
          className="border-white/70 bg-white/10 text-white hover:bg-white hover:text-primary-blue font-semibold backdrop-blur-sm"
        >
          <LogIn className="mr-2 h-4 w-4" />
          Login
        </Button>
      </Link>
      <Link to="/business-signup" onClick={() => window.scrollTo(0, 0)}>
        <Button className="bg-white text-primary-blue hover:bg-gray-100 font-semibold shadow-md">
          <UserPlus className="mr-2 h-4 w-4" />
          Sign Up
        </Button>
      </Link>
    </div>
  );
};
